module.exports = __webpack_public_path__ + "static/media/el-ateneo.15dd5774.md";